import { WorldPayState } from './../reducers/worldpay.reducer';
import { COMPLETE_ORDER_FEATURE } from './../reducers/index';
import { createSelector, createFeatureSelector } from '@ngrx/store';
import * as fromCompleteOrder from '@complete-order/store/reducers';

const getCompleteOrderState =
  createFeatureSelector<fromCompleteOrder.CompleteOrderState>(
    COMPLETE_ORDER_FEATURE
  );
export const getWorldPayState = createSelector(
  getCompleteOrderState,
  (state) => state.worldPay
);

export const getWorldPay = createSelector(
  getWorldPayState,
  (state: WorldPayState) => state.data
);

export const getWorldPayLoading = createSelector(
  getWorldPayState,
  (state: WorldPayState) => state.loading
);

export const getWorldPayLoaded = createSelector(
  getWorldPayState,
  (state: WorldPayState) => state.loaded
);

export const getWorldPayError = createSelector(
  getWorldPayState,
  (state: WorldPayState) => state.error
);
